<footer class="footer-content container-fluid gradient">
    <div class="d-lg-block d-none">
        <a class="footer-logo d-flex justify-content-center" href="">
            <img class="logo-img" src="assets/img/Component 1 1.svg" alt="سامانه هوشمند دادگام">
        </a>
    </div>
    <div class="d-flex flex-lg-row flex-column-reverse">
        <div class="d-lg-none d-block d-flex align-items-center justify-content-around">
            <div class="d-flex align-items-center footer-link my-4 per-row">
                <img referrerpolicy="origin" id="rgvjwlaojxlzjzpeapfunbqe"
                    onclick="window.open(&quot;https://logo.samandehi.ir/Verify.aspx?id=341752&amp;p=xlaoaodsrfthjyoedshwuiwk&quot;, &quot;Popup&quot;,&quot;toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30&quot;)"
                    alt="logo-samandehi" loading="lazy"
                    src="https://logo.samandehi.ir/logo.aspx?id=341752&amp;p=qftishwlnbpdyndtujynodrf"
                    class="home-namads">
            </div>
            <a referrerpolicy="origin" target="_blank"
                href="https://trustseal.enamad.ir/?id=291116&amp;Code=MLLN6eZhoSs99LygmiVI"
                rel="noopener noreferrer"><img referrerpolicy="origin" loading="lazy"
                    src="https://Trustseal.eNamad.ir/logo.aspx?id=291116&amp;Code=MLLN6eZhoSs99LygmiVI" alt="e-namad"
                    id="MLLN6eZhoSs99LygmiVI" class="home-namads" style="cursor: pointer;">
            </a>
            <div class="d-flex align-items-center footer-link my-4 per-row">
                <img onclick="window.open(&quot;https://qr.mojavez.ir/track/3410938&quot;)" loading="lazy"
                    alt="logo-kasbokar" src="assets/img/logonama.svg" class="home-namads" style="cursor: pointer;">
            </div>
            <div class="d-flex align-items-center footer-link my-4 per-row">
                <img alt="creative-units-badge" loading="lazy"
                    onclick="window.open(&quot; assets/file/creative_units.PDF&quot;)"
                    src="assets/img/creative_units_logo.png" class="home-namads creative" style="cursor: pointer;">
            </div>
            <div class="d-flex align-items-center footer-link my-4 per-row">
                <img onclick="window.open(&quot; assets/file/nezam_senfi.pdf&quot;)" loading="lazy"
                    src="assets/img/NSR-Nezam-Senfi-Logo.svg" alt="irannsr" class="home-namads creative">
            </div>
        </div>
        <div class="footer-description">
            <a class="footer-logo d-lg-block d-none" href="">
                <img src="assets/img/Group 26540 1.svg" alt="سامانه هوشمند دادگام">
            </a>
            <div>
                <div class="about-us">
                    <span class="footer-text">
                        تيم حقوقي دادگام با همكاري جمعي از نخبگان حقوقي ، اعم از اعضاي هيأت
                        علمي دانشگاه، وكلاي پايه يك دادگستري تشكيل و با به كارگيري فناوري
                        هاي نوين در خدمت حقوق، سامانه اي را جهت ارائه خدمات حقوقي سريع، دقيق
                        و باكيفيت راه اندازي نموده تا در جهت پیشبرد عدالت و توسعه حقوق
                        شهروندی تاثیر گذار باشد. سامانه هوشمند دادگام یک پلتفرم آنلاین
                        است....
                    </span>
                    <span class="footer-show-more">
                        <a (click)="gotoPage('aboutus')" class="btn show-more d-flex align-items-center gap">
                            <span> بیشتر بخوانید</span>
                            <i class="fal fa-arrow-left show-more-icon"></i>
                        </a>
                    </span>
                </div>
                <div class="phone-location">
                    <div onclick="window.open('tel:021-28426644');"
                        class="d-flex align-items-center gap py-3 footer-phone">
                        <img src="assets/img/phone.svg" alt="phone" loading="lazy">
                        <span>021-28426644</span>
                    </div>
                    <a target="_blank"
                        href="https://balad.ir/location?latitude=31.838549&amp;longitude=54.368150&amp;zoom=16.500000"
                        rel="noopener noreferrer" class="d-flex align-items-center gap footer-location">
                        <img src="assets/img/location.svg" alt="location" loading="lazy">
                        <span>یزد، بلوار دانشگاه، جنب پارک پهلوان یزدی</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="footer-links d-flex flex-lg-row flex-column">
            <div class="dadgam-access d-flex justify-content-around p-lg-0 pt-3">
                <div class="d-flex flex-column dadgam-access-container">
                    <p class="dadgam-access-title footer-title">دادگام</p>
                    <div class="d-flex flex-column dadgam-access-links">
                        <a (click)="gotoPage('aboutus')" class="d-flex align-items-center footer-link per-row">
                            <span>درباره ما</span>
                        </a>
                        <a (click)="gotoPage('contact-us')" class="d-flex align-items-center footer-link per-row">
                            <span>تماس با ما</span>
                        </a>
                        <a (click)="gotoPage('mag')" class="d-flex align-items-center footer-link per-row">
                            <span>مجله دادگام</span>
                        </a>
                        <a (click)="gotoPage('blog')" class="d-flex align-items-center footer-link per-row">
                            <span>مقالات</span>
                        </a>
                    </div>
                </div>
                <div class="d-flex flex-column dadgam-access-container">
                    <p class="quick-access-title footer-title">دسترسی سریع</p>
                    <div class="d-flex flex-column dadgam-access-links">
                        <a (click)="gotoPage('privacy')" class="d-flex align-items-center footer-link">
                            <span>قوانین و مقررات</span>
                        </a>
                        <a (click)="gotoPage('petition')" class="d-flex align-items-center footer-link">
                            <span>دادخواست‌ها</span>
                        </a>
                        <a (click)="gotoPage('contract')" class="d-flex align-items-center footer-link">
                            <span>قرارداد</span>
                        </a>
                        <a (click)="gotoPage('judicial')" class="d-flex align-items-center footer-link">
                            <span>اوراق قضایی</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="dadgam-share p-lg-0 p-3">
                <p class="share-title footer-title">ما را دنبال کنید</p>
                <div class="d-flex justify-content-lg-between justify-content-evenly mb-lg-3 m-0">
                    <a href="https://instagram.com/daadgam.group?igshid=MzRlODBiNWFlZA=="
                        class="d-flex align-items-center footer-link">
                        <div class="icon-back">
                            <img src="assets/img/instagram.svg" loading="lazy" alt="instagram" class="img">
                            <img src="assets/img/instagram-blue.svg" loading="lazy" alt="instagram"
                                class="responsive-icon">
                        </div>
                    </a>
                    <a href="https://web.whatsapp.com/" class="d-flex align-items-center footer-link per-row">
                        <div class="icon-back">
                            <img src="assets/img/WA.svg" loading="lazy" alt="WA" class="img">
                            <img src="assets/img/WA-blue.svg" loading="lazy" alt="WA" class="responsive-icon">
                        </div>
                    </a>
                    <a href="https://t.me/daadgam" class="d-flex align-items-center footer-link per-row">
                        <div class="icon-back">
                            <img src="assets/img/telegram.svg" loading="lazy" alt="telegram" class="img">
                            <img src="assets/img/teg-blue.svg" loading="lazy" alt="telegram" class="responsive-icon">
                        </div>
                    </a>
                    <a href="https://web.eitaa.com/#@daadgam" class="d-flex align-items-center footer-link per-row">
                        <div class="icon-back">
                            <img src="assets/img/eita.svg" loading="lazy" alt="eitaa" class="img">
                            <img src="assets/img/eitaa-blue.svg" loading="lazy" alt="eitaa" class="responsive-icon">
                        </div>
                    </a>
                </div>
                <div class="logo d-lg-block d-none">
                    <div class="d-flex justify-content-start flex-wrap">
                        <div class="d-flex align-items-center footer-link">
                            <img referrerpolicy="origin" loading="lazy" id="rgvjwlaojxlzjzpeapfunbqe"
                                onclick="window.open(&quot;https://logo.samandehi.ir/Verify.aspx?id=341752&amp;p=xlaoaodsrfthjyoedshwuiwk&quot;, &quot;Popup&quot;,&quot;toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30&quot;)"
                                alt="logo-samandehi"
                                src="https://logo.samandehi.ir/logo.aspx?id=341752&amp;p=qftishwlnbpdyndtujynodrf"
                                class="home-namads">
                        </div>
                        <div class="d-flex align-items-center footer-link">
                            <img onclick="window.open(&quot;https://qr.mojavez.ir/track/3410938&quot;)"
                                alt="logo-kasbokar" loading="lazy" src="assets/img/logonama.svg" class="home-namads"
                                style="cursor: pointer;">
                        </div>
                        <a referrerpolicy="origin" target="_blank"
                            href="https://trustseal.enamad.ir/?id=291116&amp;Code=MLLN6eZhoSs99LygmiVI"
                            rel="noopener noreferrer" class="footer-link">
                            <img referrerpolicy="origin" loading="lazy"
                                src="https://Trustseal.eNamad.ir/logo.aspx?id=291116&amp;Code=MLLN6eZhoSs99LygmiVI"
                                alt="e-namad" id="MLLN6eZhoSs99LygmiVI" class="home-namads"
                                style="cursor: pointer;"></a>
                        <div class="d-flex justify-content-center align-items-center footer-link">
                            <img alt="creative-units-badge" loading="lazy"
                                onclick="window.open(&quot;assets/file/creative_units.PDF&quot;)"
                                src="assets/img/creative_units_logo.png" class="home-namads creative"
                                style="cursor: pointer;">
                        </div>
                        <div class="d-flex align-items-center footer-link">
                            <img onclick="window.open(&quot;assets/file/nezam_senfi.pdf&quot;)" loading="lazy"
                                src="assets/img/NSR-Nezam-Senfi-Logo.svg" alt="irannsr" class="home-namads creative">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>

<!-- Copyright -->
<div class="text-center padding gradient copyright-text p-3">
    تمامی حقوق این وب سایت متعلق به شرکت دادگران فناور پیشگام خلاق می باشد.
    <p class="text-reset fw-bold">1400-1402</p>
</div>
<!-- Copyright -->